import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconScratchCard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconScratchCard"><Path fillRule="evenodd" clipRule="evenodd" d="M22 4H2V20H22V4ZM11.5852 7.71255L11.9415 8.66263L15.8356 8.01361L16.4061 9.91381L13.4772 11.2156L15.2142 11.0071L15.7627 12.7356L17.7758 12.3175L18.1825 14.2758L9.98113 15.9791L9.30263 14.1201L10.2294 13.6196L7.11915 13.9929L6.59386 12.0862L8.4108 11.2787L7.1644 11.4864L6.64888 9.56367L11.5852 7.71255Z" fill="currentColor"/></CentralIconBase>;
});

export default IconScratchCard;
